import React, { useContext } from "react";
import { Select } from "antd";
import { AppContext } from "../../context";
function SelectQuantity({ quantity = 1, setQuantityFn, options }) {
  const { t } = useContext(AppContext);
  return (
    <div>
      <div style={{ marginTop: 10, display: "inline" }}>
        <strong>{t("quantity")}:</strong>
      </div>
      <Select
        placeholder={t("quantity")}
        options={options}
        value={quantity}
        onChange={setQuantityFn}
        bordered={false}
        style={{ marginTop: 10 }}
      />
    </div>
  );
}

export default SelectQuantity;
